//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IOpObject, IOpData } from "../util/interfaces";
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'
import { OpDataList } from '../util/op-data-list'
import { OpDataType } from '../core/op-data-type'
import { OpDeviceConnectionData } from '../custom/op-device-connection-data'

export class OpDeviceConnection implements IReferenceType, IOpObject, IOpChangeState {

    // region Properties

    public idDeviceConnection: number
    public serialNbr: number
    public serialNbrParent: number
    public time: Date

    // endregion

    // region Navigation Properties
    // endregion

    // region Custom Properties
    public latitude: number
    public longitude: number

    public parentLatitude: number
    public parentLongitude: number

    public idDeviceType: number
    public idDeviceTypeParent: number
    // endregion

    // region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj, false)
    }

    // endregion

    // region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // endregion

    // region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDeviceConnection
    }
    public getReferenceKey(): number {
        return this.idDeviceConnection
    }
    public getReferenceValue(): any {
        return this
    }

    // endregion

    // region IOpObject

    public get idObject(): any {
        return this.idDeviceConnection
    }
    public set idObject(idObject: any) {
        this.idDeviceConnection = idObject
    }

    public dataList: OpDataList<OpDeviceConnectionData> = new OpDataList<OpDeviceConnectionData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string

    public toJSON(compressed: boolean): any {
        return {
            ID_DEVICE_CONNECTION: this.idDeviceConnection,
            idDeviceType: this.idDeviceType,
            idDeviceTypeParent: this.idDeviceTypeParent,
            DataList: this.dataList ? this.dataList.ToJSON() : null,
            OpState: this.opState
        }
    }

    public fromJSON(opObj: any, compressed: boolean): any {
        if (opObj) {
            this.idDeviceConnection = opObj.ID_DEVICE_CONNECTION
            this.serialNbr = opObj.SERIAL_NBR
            this.serialNbrParent = opObj.SERIAL_NBR_PARENT
            this.idDeviceType = opObj.IdDeviceType ? opObj.IdDeviceType : opObj.idDeviceType
            this.idDeviceTypeParent = opObj.IdDeviceTypeParent ? opObj.IdDeviceTypeParent : opObj.idDeviceTypeParent
            this.time = opObj.TIME

            if (opObj.DataList) {
                this.dataList.push(...opObj.DataList.map(data => new OpDeviceConnectionData(data)))
            } else {
                this.dataList = new OpDataList<OpDeviceConnectionData>()
            }

            this.dynamicValues = opObj.dynamicValues  // TODO na slownik

            this.opState = opObj.OpState
        } else {
            this.dataList = new OpDataList<OpDeviceConnectionData>()
        }
    }

    public toString() {
        return 'DeviceConnection [' + this.idDeviceConnection + ']'
    }

    // endregion

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDeviceConnection[]): JQueryPromise<OpDeviceConnection[]> {
        let defered = $.Deferred<OpDeviceConnection[]>()

        if (dataProvider && list && list.length > 0) {
            let idDataType: number[] = CommonHelper.getIdDataTypesFromObjectList<OpDeviceConnection>(list)

            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType]).then(dict => {

                let dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)

                if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                }

                list.forEach(item => {
                    if (item.dataList) {
                        item.dataList
                            .toArray()
                            .forEach((data: OpDeviceConnectionData) => {
                                data.dataType = dataTypeDict.tryGetValue(data.idDataType)
                            })
                    }
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }

    public static fromIOpObject(object: IOpObject): OpDeviceConnection {

        let deviceConnection: OpDeviceConnection = null

        if (object) {
            deviceConnection = new OpDeviceConnection(null)

            deviceConnection.idDeviceConnection = object.idObject

            if (object instanceof OpDeviceConnection) {
                let dcItem = object as OpDeviceConnection

                if (dcItem) {
                    deviceConnection.idDeviceType = dcItem.idDeviceType
                    deviceConnection.idDeviceTypeParent = dcItem.idDeviceTypeParent
                }
            }

            deviceConnection.opState = object.opState

            if (object.dataList) {
                deviceConnection.dataList.push(...object.dataList.toArray().map((data: IOpData) => OpDeviceConnectionData.fromIOpData(data)))
            }
        }

        return deviceConnection
    }
}